





















































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
@Component({})
export default class SwLoginEagle extends SwExtendedVue {
}
